"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _slice = require("@lce/slice");

var _Links = _interopRequireDefault(require("../Links"));

var Styled = _interopRequireWildcard(require("./Modal.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Button = function Button(_a) {
  var onClick = _a.onClick,
      children = _a.children;
  return _react["default"].createElement(Styled.Button, {
    "aria-label": "Account Menu",
    "data-testid": "header__hamburger-button",
    id: "header__hamburger-button",
    onClick: onClick
  }, children);
};

var Modal = function Modal(_a) {
  var isOpen = _a.isOpen,
      setIsOpen = _a.setIsOpen;

  var handleOnClose = function handleOnClose() {
    var _a;

    setIsOpen(false);
    (_a = document.getElementById('header__hamburger-button')) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleOnOpen = function handleOnOpen() {
    return setIsOpen(true);
  };

  return _react["default"].createElement(_react["default"].Fragment, null, isOpen ? _react["default"].createElement(_slice.Layer, {
    closeOnClickOutside: true,
    isOpen: isOpen,
    lockBodyScroll: true,
    onClose: handleOnClose,
    overlay: false
  }, _react["default"].createElement(_focusTrapReact["default"], {
    active: isOpen,
    focusTrapOptions: {
      allowOutsideClick: true
    }
  }, _react["default"].createElement(Styled.Modal, {
    "aria-label": "Account Menu-Links",
    "aria-modal": "true",
    role: "dialog"
  }, _react["default"].createElement(Styled.ButtonContainer, null, _react["default"].createElement(Button, {
    "data-testid": "header__close",
    onClick: handleOnClose
  }, _react["default"].createElement(_reactFeather.X, {
    size: 44
  }))), _react["default"].createElement(Styled.Content, {
    "data-testid": "header__hamburger-account"
  }, _react["default"].createElement(_Links["default"], null))))) : _react["default"].createElement(Button, {
    "data-testid": "header__open",
    onClick: handleOnOpen
  }, _react["default"].createElement(_reactFeather.Menu, {
    size: 44
  })));
};

var _default = Modal;
exports["default"] = _default;